/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Periods_HintInputs */



/**
* | output |
* | --- |
* | "A billing period is one calendar month, so twelve is a year." |
*
* @param {Partner_Add_Customer_Contract_Periods_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_periods_hint = /** @type {((inputs?: Partner_Add_Customer_Contract_Periods_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Periods_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Abrechnungsperiode ist ein Kalendermonat, zwölf sind also ein Jahr.")
	return /** @type {LocalizedString} */ ("A billing period is one calendar month, so twelve is a year.")
});